import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Variation from "./CovidLethalityMapVariation";
import Dead from "./CovidLethalityMapDead";

const Container = styled.div`
  margin: 60px 0 70px;

  @media (max-width: 767px) {
    margin: 45px 0 0;
  }
`;

function CovidMapController({ version }) {
  const [variationState, setVariationState] = useState("normal");
  const [deadState, setDeadState] = useState("normal");

  function handleVariationToggleZoom() {
    setVariationState((state) => {
      setDeadState(state === "zoomed" ? "normal" : "minimized");

      return state === "zoomed" ? "normal" : "zoomed";
    });
  }

  function handleDeadToggleZoom() {
    setDeadState((state) => {
      setVariationState(state === "zoomed" ? "normal" : "minimized");

      return state === "zoomed" ? "normal" : "zoomed";
    });
  }

  return (
    <Container>
      <Variation
        version={version}
        variationZoomState={{
          zoomState: variationState,
          toggleZoom: handleVariationToggleZoom,
        }}
      />
      <Dead
        version={version}
        deadZoomState={{
          zoomState: deadState,
          toggleZoom: handleDeadToggleZoom,
        }}
      />
    </Container>
  );
}

CovidMapController.propTypes = {
  version: PropTypes.oneOf(["v1", "v2"]).isRequired,
};

export default CovidMapController;
